var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat36X36X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 28 11 C 28.552 11 29 11.448 29 12 C 29 12.552 28.552 13 28 13 C 27.448 13 27 12.552 27 12 C 27 11.448 27.448 11 28 11 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9 25 C 9.552 25 10 25.448 10 26 C 10 26.552 9.552 27 9 27 C 8.448 27 8 26.552 8 26 C 8 25.448 8.448 25 9 25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 26 C 5.552 26 6 26.448 6 27 C 6 27.552 5.552 28 5 28 C 4.448 28 4 27.552 4 27 C 4 26.448 4.448 26 5 26 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 27 19 C 27.552 19 28 19.448 28 20 C 28 20.552 27.552 21 27 21 C 26.448 21 26 20.552 26 20 C 26 19.448 26.448 19 27 19 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 23 C 25.552 23 26 23.448 26 24 C 26 24.552 25.552 25 25 25 C 24.448 25 24 24.552 24 24 C 24 23.448 24.448 23 25 23 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 27 C 1.552 27 2 27.448 2 28 C 2 28.552 1.552 29 1 29 C 0.448 29 0 28.552 0 28 C 0 27.448 0.448 27 1 27 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21 25 C 21.552 25 22 25.448 22 26 C 22 26.552 21.552 27 21 27 C 20.448 27 20 26.552 20 26 C 20 25.448 20.448 25 21 25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9 1 C 9.552 1 10 1.448 10 2 C 10 2.552 9.552 3 9 3 C 8.448 3 8 2.552 8 2 C 8 1.448 8.448 1 9 1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 3 C 5.552 3 6 3.448 6 4 C 6 4.552 5.552 5 5 5 C 4.448 5 4 4.552 4 4 C 4 3.448 4.448 3 5 3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 7 C 3.552 7 4 7.448 4 8 C 4 8.552 3.552 9 3 9 C 2.448 9 2 8.552 2 8 C 2 7.448 2.448 7 3 7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13 0 C 13.552 0 14 0.448 14 1 C 14 1.552 13.552 2 13 2 C 12.448 2 12 1.552 12 1 C 12 0.448 12.448 0 13 0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 19 C 3.552 19 4 19.448 4 20 C 4 20.552 3.552 21 3 21 C 2.448 21 2 20.552 2 20 C 2 19.448 2.448 19 3 19 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 23 C 2.552 23 3 23.448 3 24 C 3 24.552 2.552 25 2 25 C 1.448 25 1 24.552 1 24 C 1 23.448 1.448 23 2 23 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 15 C 2.552 15 3 15.448 3 16 C 3 16.552 2.552 17 2 17 C 1.448 17 1 16.552 1 16 C 1 15.448 1.448 15 2 15 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13 26 C 13.552 26 14 26.448 14 27 C 14 27.552 13.552 28 13 28 C 12.448 28 12 27.552 12 27 C 12 26.448 12.448 26 13 26 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28 15 C 28.552 15 29 15.448 29 16 C 29 16.552 28.552 17 28 17 C 27.448 17 27 16.552 27 16 C 27 15.448 27.448 15 28 15 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21 1 C 21.552 1 22 1.448 22 2 C 22 2.552 21.552 3 21 3 C 20.448 3 20 2.552 20 2 C 20 1.448 20.448 1 21 1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 27 7 C 27.552 7 28 7.448 28 8 C 28 8.552 27.552 9 27 9 C 26.448 9 26 8.552 26 8 C 26 7.448 26.448 7 27 7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 3 C 25.552 3 26 3.448 26 4 C 26 4.552 25.552 5 25 5 C 24.448 5 24 4.552 24 4 C 24 3.448 24.448 3 25 3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17 26 C 17.552 26 18 26.448 18 27 C 18 27.552 17.552 28 17 28 C 16.448 28 16 27.552 16 27 C 16 26.448 16.448 26 17 26 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17 0 C 17.552 0 18 0.448 18 1 C 18 1.552 17.552 2 17 2 C 16.448 2 16 1.552 16 1 C 16 0.448 16.448 0 17 0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 11 C 2.552 11 3 11.448 3 12 C 3 12.552 2.552 13 2 13 C 1.448 13 1 12.552 1 12 C 1 11.448 1.448 11 2 11 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8 16 L 18 16 L 18 17 L 8 17 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8 12 L 22 12 L 22 13 L 8 13 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat36X36X);
export default __webpack_public_path__ + "static/media/chat-36x36x.bfc51a5feaaa11e3e4a144030873e9c2.svg";
export { ForwardRef as ReactComponent };